var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.infoItem)?_c('div',[_c('span',{staticClass:"task-type px-2",style:(_vm.getSpanStyle(_vm.infoItem))},[_c('span',{staticClass:"opposite-color-text"},[_vm._v(" "+_vm._s(_vm.infoItem.text)+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }